(function () {
  var FLOOR = 12;

  function fitOne(h) {
    h.style.fontSize = '';
    var size = parseFloat(getComputedStyle(h).fontSize);
    if (!size) return FLOOR;
    var guard = 48;
    while (h.scrollWidth > h.clientWidth && size > FLOOR && guard-- > 0) {
      size -= 1;
      h.style.fontSize = size + 'px';
    }
    return size;
  }

  function fitSection(sec) {
    var titles = [].slice.call(sec.querySelectorAll('.th-collection-card__title'));
    if (!titles.length) return;
    var min = Infinity;
    titles.forEach(function (h) { min = Math.min(min, fitOne(h)); });
    titles.forEach(function (h) { h.style.fontSize = min + 'px'; });
  }

  var pending = new WeakSet();
  function schedule(sec) {
    if (pending.has(sec)) return;
    pending.add(sec);
    requestAnimationFrame(function () {
      pending.delete(sec);
      fitSection(sec);
    });
  }

  function fitAll() {
    document.querySelectorAll('.th-collection').forEach(schedule);
  }

  function updateProgress(sc) {
    var sw = sc.swiper;
    if (!sw) return;
    var content = sc.closest('tab-content');
    var bar = content && content.querySelector('.th-collection__progress-bar');
    if (!bar) return;
    var total = sw.slides ? sw.slides.length : 0;
    var perView = sw.params && sw.params.slidesPerView;
    if (!total || typeof perView !== 'number' || perView >= total) {
      bar.style.setProperty('--th-progress-width', '100%');
      bar.style.setProperty('--th-progress-x', '0');
      return;
    }
    var ratio = perView / total;
    bar.style.setProperty('--th-progress-width', ratio * 100 + '%');
    bar.style.setProperty('--th-progress-x', (sw.progress || 0) * ((1 / ratio) - 1) * 100 + '%');
  }

  function updateSwipers() {
    document.querySelectorAll('.th-collection swiper-container').forEach(function (sc) {
      if (sc.shadowRoot) {
        var sd = sc.shadowRoot.querySelector('.swiper');
        if (sd) {
          sd.style.setProperty('padding-left', '0', 'important');
          sd.style.setProperty('padding-right', '0', 'important');
          sd.style.setProperty('padding-top', '0', 'important');
          sd.style.setProperty('padding-bottom', '0', 'important');
        }
      }
      if (sc.swiper && sc.swiper.update) sc.swiper.update();
      if (!sc.dataset.thProgressBound && sc.swiper && sc.swiper.on) {
        sc.dataset.thProgressBound = '1';
        sc.swiper.on('progress', function () { updateProgress(sc); });
        sc.swiper.on('resize', function () { updateProgress(sc); });
      }
      updateProgress(sc);
    });
  }

  function init() {
    updateSwipers();
    fitAll();
    if (window.ResizeObserver) {
      document.querySelectorAll('.th-collection').forEach(function (sec) {
        var ro = new ResizeObserver(function () { schedule(sec); });
        sec.querySelectorAll('.th-collection-card').forEach(function (card) { ro.observe(card); });
        var sc = sec.querySelector('swiper-container');
        if (sc) {
          new ResizeObserver(function () {
            if (sc.swiper && sc.swiper.update) sc.swiper.update();
            schedule(sec);
          }).observe(sc);
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', function () {
    updateSwipers();
    fitAll();
    setTimeout(function () { updateSwipers(); fitAll(); }, 300);
  });
  window.addEventListener('resize', function () { updateSwipers(); fitAll(); });
})();
